import getConfig from '../app/config';
import formatBytes from '../shared/formatBytes';
import PriceIncluded from './price-included';
import { useInView } from "react-intersection-observer";
const Price = ({ pricingPlan, currency, registerUrl, plan, includeTax }: any) => {

  const options = { threshold: 0.3, triggerOnce: true, rootMargin: "0px 0px 0px 0px" };
  const [ref, inView] = useInView(options);

  let registerWithTypeUrl = registerUrl;
  if (registerUrl.indexOf("?") > -1) {
    registerWithTypeUrl += "&";
  } else {
    registerWithTypeUrl += "?";
  }

  registerWithTypeUrl += "pricingPlan=" + pricingPlan;

  const { beta: isBeta } = getConfig() as any;

  const price = includeTax && plan.taxAmount ? plan.price + plan.taxAmount : plan.price;
  return (
    <div ref={ref} className={`card price-card ${inView ? "price-card-in-view" : ""}`}>
      <div className="price-card-content">
        {isBeta && <span className="tag is-purple price-is-beta">Beta</span>}
        <header className="card-header">
          <div className="price-card-header-title is-size-5">
            {plan.name}
          </div>
        </header>
        <div>
          {plan.description}
        </div>
        <div>
          <span className={`price-cost ${price > 0 && isBeta ? "price-strike-through" : ""}`}><span dangerouslySetInnerHTML={{ __html: currency }}></span>{price}</span>{price > 0 && isBeta && <span className="price-cost"> <span dangerouslySetInnerHTML={{ __html: currency }}></span>0</span>} Per month{price > 0 && isBeta && <span>*</span>}
        </div>
        <PriceIncluded included={`${plan.maxFilms} film${plan.maxFilms > 1 ? 's' : ''}`} />
        <PriceIncluded included={`${plan.maxCollaboratorsPerFilm ?? 'Unlimited'} users per film`} />
        <PriceIncluded included={`${formatBytes(plan.maxBytes)} storage`} />
        <a href={`${registerWithTypeUrl}`} className="button price-button">{price > 0 && !isBeta ? "Subscribe now" : "Try now"}</a>
      </div>

    </div>
  )
}

export default Price;